import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { HeadingRegularVariants, H6 } from "../../index";
import { processColorMode } from "../../theme";
export const SectionTitle = ({ title, subtitle, mode = "dark" }) => {
    return (_jsx(Flex, { sx: Object.assign(Object.assign({}, processColorMode(mode)), { width: "100%", flex: 1 }), children: _jsxs(Box, { children: [subtitle && _jsx(H6, { children: subtitle }), title && (_jsx("h2", { className: "color-mode-title", sx: {
                        variant: `text.${HeadingRegularVariants.second}`,
                        maxWidth: "30ch"
                    }, children: title }))] }) }));
};
//# sourceMappingURL=SectionTitle.js.map